<template>
  <b-modal
    id="addContractInvoiceModal"
    cancel-variant="outline-secondary"
    :ok-title="$t('save')"
    :cancel-title="$t('general.close')"
    centered
    size="xl"
    no-close-on-backdrop
    :title="addContractInvoiceType == false ? $t('add_invoice') : $t('edit_invoice')"
    @ok="onSave($event)"
    @cancel="onCancel()"
    @close="onCancel()"
    @show="onShow()"
  >
    <validation-observer ref="contractValidations">
      <b-row>
        <b-col class="col-12">
          <b-form-group :label="$t('recipient')">
            <validation-provider
              #default="{ errors }"
              :name="$t('recipient')"
              rules="required"
            >
              <v-select
                v-model="filter.author"
                class="bg-white rounded"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :get-option-label="el => { return el.first_name + ' ' + el.last_name}"
                :options="GET_APPLICATION_AUTHOR.results"
                :reduce="(p) => p.id"
                @input="onFiltered"
                @search="onAuthorSearch"
              />
            <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>



      <b-row class="treaty mt-2">
        <b-col
          md="12"
          class="mb-2 text-center"
        >
          <h2>{{$t('subject_of_the_contract')}}</h2>
        </b-col>

        <b-col class="col-md-12 mb-3">
          <div class="d-flex align-items-center justify-content-between">
            <h4 class="mb-0">
              {{$t('reference.material')}}
            </h4>

            <b-button
              v-if="!viewMode && ($route.name != 'edit-agreements')"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              @click="openModal(true)"
            >
              <feather-icon
                icon="PlusIcon"
                size="16"
              />
              {{$t('add')}}
            </b-button>
          </div>
          <MaterialsTable :invoice="true"/>
        </b-col>
        <b-col class="col-md-12 mb-2">
          <div class="d-flex align-items-center justify-content-between">
            <h4 class="mb-0">
              {{$t('reference.instrument')}}
            </h4>

            <b-button
              v-if="!viewMode && ($route.name != 'edit-agreements')"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              @click="openModal(false)"
            >
              <feather-icon
                icon="PlusIcon"
                size="16"
              />
              {{$t('add')}}
            </b-button>
          </div>
          <InstrumentsTable :invoice="true"/>
        </b-col>
      </b-row>


    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,
  BButton
} from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

import MaterialsTable from './../tables/materialsTable.vue'
import InstrumentsTable from './../tables/instrumentsTable.vue'
import priceFormatMixin from '@/mixins/priceFormatMixin'

export default {
  components: {
    BModal,
    BFormInput,
    BFormGroup,
    vSelect,
    BRow,
    ValidationObserver,
    ValidationProvider,
    BCol,
    BButton,

    MaterialsTable,
    InstrumentsTable,

  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [priceFormatMixin],
  props: {
    
  },
  data() {
    return {
      // =============== PRIMARY_DATA START ===============
      filter: {
        author: null,
        selected: false,
      },
      // =============== PRIMARY_DATA END ===============
    }
  },
  watch: {
    addContractInvoiceType(newValue){
      if(newValue){
        let a = this.invoiceItems.find((elem) => elem.id == this.invoice_id)
        this.filter.author = a.receiving.id

        // console.log(this.invoiceItems)
        // a.goods.forEach((elem) => {
        //   elem.count = this.$_formatPriceMixin(elem.quantity)
        // })

        // a.instruments.forEach((elem) => {
        //   elem.count = this.$_formatPriceMixin(elem.quantity)
        // })

        // this.materialItems = a.goods
        // this.instrumentItems = a.instruments
      }
    }
  },
  computed: {
    ...mapState('agrements', ['viewMode']),
    ...mapGetters('application', [
      'GET_APPLICATION_AUTHOR',
    ]),






    // ========================= SETTERS_AND_GETTERS START =========================
    materialItems: {
      get: function () {
        return this.$store.state.agrements.materialItems;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_MATERIAL_ITEMS', newValue)
      }
    },
    instrumentItems: {
      get: function () {
        return this.$store.state.agrements.instrumentItems;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_INSTRUMENT_ITEMS', newValue)
      }
    },
    addContractInvoiceType: {
      get: function () {
        return this.$store.state.agrements.addContractInvoiceType;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_CONTRACT_INVOICE_TYPE', newValue)
      }
    },
    invoiceItems: {
      get: function () {
        return this.$store.state.agrements.invoiceItems;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_INVOICE_ITEMS', newValue)
      }
    },
    invoice_id: {
      get: function () {
        return this.$store.state.agrements.invoice_id;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_INVOICE_ID', newValue)
      }
    },
    addNewContractInvoice: {
      get: function () {
        return this.$store.state.agrements.addNewContractInvoice;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_NEW_CONTRACT_INVOICE', newValue)
      }
    },
    // ========================= SETTERS_AND_GETTERS END =========================






  },
  async mounted() {
    // if(this.$route.query.view){
    //   this.viewMode = true
    // }
    await this.FETCH_APPLICATION_AUTHOR({ mini: true, role_unique_name: 'chief_manager'})
  },
  methods: {
    ...mapMutations('application', [
      'SET_APPLICATION_USER',
    ]),
    ...mapActions('agrements', [
      'CREATE_CONTRACT_INVOICE',
      'UPDATE_CONTRACT_INVOICE'
    ]),
    ...mapActions('application', [
      'FETCH_APPLICATION_AUTHOR',
    ]),





    // ========================= ON_SAVE START =========================
    onShow(){
      this.filter = {
        author: null,
        selected: false,
      }
    },
    // ========================= ON_SAVE END =========================






    // ========================= ON_SAVE START =========================
    async onSave(bvModalEvent) {
      bvModalEvent.preventDefault()
      await this.$refs.contractValidations.validate().then(async success => {

      if (!success) return
        let goods = this.materialItems.map((item) => ({
            good_id: item.good.id, 
            count: parseFloat(item.count.toString().replace(/,/g, '')),
        }))

        console.log(this.instrumentItems)
        console.log(this.addContractInvoiceType)
        let instruments = this.instrumentItems.map((item) => ({
            instrument_id: item.instrument.id, 
            count: parseFloat(item.count.toString().replace(/,/g, '')),
        }))

     


        if(this.addContractInvoiceType == false){
          await this.CREATE_CONTRACT_INVOICE({
            contract: this.$route.params.id,
            receiving: this.filter.author,
            goods, goods,
            instruments, instruments,
          })
        }else{
          await this.UPDATE_CONTRACT_INVOICE({data: {
            contract: this.$route.params.id,
            receiving: this.filter.author,
            goods, goods,
            instruments, instruments,
          }, id: this.invoice_id})
        }
        this.$_okToast()




        // this.$bvModal.hide('addContractInvoiceModal')
        this.$nextTick(() => {
          this.$emit('refreshPage', true)
          // this.allData = {
          //   category: null,
          //   good: null,
          //   price: null,
          //   count: null,
          //   good_id: null,
          //   instrument_id: null,
          // }
          this.addContractInvoiceType = false
          this.$bvModal.hide('addContractInvoiceModal')
        })
      }).catch((err) => {
        console.log(err)
        this.$_errToast(err)
      })

      
    },
    // ========================= ON_SAVE END =========================











    // ========================= ON_CANCEL START =========================
    onCancel() {
      this.addContractInvoiceType = false
      this.addNewContractInvoice = false
    },
    // ========================= ON_SAVE END =========================











    // ========================= OTHERS START =========================
    onFiltered(value) {
      if(value){
        this.selected = true
      }else if(value == ''){
        this.selected = false
      }else{
        this.selected = false
      }
    },
    async onAuthorSearch(value){
      if(value){
        clearTimeout(this._timerId)
        this._timerId = setTimeout( async () => {
          await this.FETCH_APPLICATION_AUTHOR({ mini: true, search: value, role_unique_name: 'chief_manager'})
        }, 500)
      }else if(value == '' && this.selected == false){
        clearTimeout(this._timerId)
        this._timerId = setTimeout( async () => {
          await this.FETCH_APPLICATION_AUTHOR({ mini: true, search: value, role_unique_name: 'chief_manager'})
        }, 500)
      }
    },
    // ========================= OTHERS END =========================







    
  },
}
</script>

<style scoped>
</style>
